// @/src/types/Channel.ts

import { IChannel } from "./IChannel";

export class Channel implements IChannel {
    id: number = 0;
    platform_id: string = '';
    platform: string = '';
    link: string = '';
    username: string = '';
    title: string = '';
    about: string = '';
    category: string = '';
    country: string | null = null;
    language: string | null = null;
    image100: string = '';
    image640: string = '';
    participants_count: number = 0;
    posts_count: number = 0;
    avg_post_reach: number | null = null;
    adv_post_reach_12h: number | null = null;
    adv_post_reach_24h: number | null = null;
    adv_post_reach_48h: number | null = null;
    err_percent: number | null = null;
    err24_percent: number | null = null;
    er_percent: number | null = null;
    daily_reach: number | null = null;
    ci_index: number | null = null;
    mentions_count: number | null = null;
    forwards_count: number | null = null;
    mentioning_channels_count: number | null = null;
    rkn: string | null = null;
    rknLink: string | null = null;
    rknDate: string | null = null;
    rknSource: string | null = null;

    // Опциональные
    peer_type?: string;
    active_usernames?: string[];
    tgstat_restrictions?: any[];
    rkn_verification?: any;
    created_at?: number;
    access?: string;

    constructor(o: Partial<IChannel>) {
        Object.assign(this, o);
    }

    // Геттеры (для удобства и совместимости со старым кодом)
    public get platformId(): string | number { return this.platform_id; }
    public get participantsCount(): number { return this.participants_count; }
    public get postsCount(): number { return this.posts_count; }
    public get avgPostReach(): number | null { return this.avg_post_reach; }
    public get advPostReach12h(): number | null { return this.adv_post_reach_12h; }
    public get advPostReach24h(): number | null { return this.adv_post_reach_24h; }
    public get advPostReach48h(): number | null { return this.adv_post_reach_48h; }
    public get errPercent(): number | null { return this.err_percent; }
    public get err24Percent(): number | null { return this.err24_percent; }
    public get erPercent(): number | null { return this.er_percent; }
    public get dailyReach(): number | null { return this.daily_reach; }
    public get ciIndex(): number | null { return this.ci_index; }
    public get mentionsCount(): number | null { return this.mentions_count; }
    public get forwardsCount(): number | null { return this.forwards_count; }
    public get mentioningChannelsCount(): number | null { return this.mentioning_channels_count; }
    public get activeUsernames(): string[] { return this.active_usernames || []; }
}